import { normalizeMigrationCpfToCnpj } from "./normalizeMigrationCpfToCnpj";
import { PutOrganizationById } from "./PutOrganizationById";

/**
 * Migra uma Organization "CPF/bus" para "CNPJ/prov".
 *
 * ATENÇÃO (decisão intencional):
 * - Este arquivo manteve o nome/export por compatibilidade com o app.
 * - A implementação foi migrada de JSON Patch para PUT, preservando o recurso atual
 *   (spread da organização + normalização) e alterando somente os campos necessários.
 */
export async function PatchOrganizationCpfToCnpj(params: {
  organization: fhir5.Organization;
  newCnpjDigits: string;
  validatedOrganization?: fhir5.Organization | null;
}) {
  const { organization, newCnpjDigits, validatedOrganization } = params;
  if (!organization?.id) {
    throw new Error("PatchOrganizationCpfToCnpj: Organization sem id");
  }
  if (!validatedOrganization) {
    throw new Error(
      "PatchOrganizationCpfToCnpj: validatedOrganization é obrigatório (retorno do Validate)",
    );
  }

  const payload = normalizeMigrationCpfToCnpj({
    currentOrganization: organization,
    newCnpjDigits,
    validatedOrganization,
  });

  return PutOrganizationById({
    organizationId: organization.id,
    fhirOrganization: payload,
  });
}
